document.addEventListener("DOMContentLoaded", () => {
  const accordionItems = document.querySelectorAll(".a_modal-item.has-children");

  accordionItems.forEach((item) => {
    const toggle = item.querySelector(".a_accordion-toggle");

    toggle.addEventListener("click", () => {
      item.classList.toggle("is-open");
    });
  });
});
